export default __webpack_public_path__ + "static/media/top-plaque.b3505aaa.gif";